import React from 'react';
import {withNamespaces} from "react-i18next";
import SearchFormContainer from "../containers/SearchFormContainer";
import Optimalle from "./Optimalle";

const OptimallesListPage = ({ t, optimalles, promoted, filtersEmpty, isLoading, reachedEnd }) => (<div className="optimalles-list">
    <div className="page-head">
        <div className="titles container">
            <h1 className="uptitle">optimalle</h1>
            <h2 className="title">Prix malins sur vos services randos</h2>
        </div>
        <SearchFormContainer />
    </div>
    {filtersEmpty &&
    <section className="featured">
        <div className="container">
            <div className="section-titles">
                <h2>À la une :</h2>
                <p>Les dernières optimalles</p>
            </div>
            <ul className="g-optimalle-list">
                {promoted.length > 0 && promoted.map(optimalle => <Optimalle key={optimalle.id}
                                                                             optimalle={optimalle}/>)}

            </ul>
        </div>
    </section>
    }

    <section className="container">
        <div className="section-titles">
            <h2>Toutes les optimalles</h2>
        </div>
        {optimalles.length > 0 && <ul className="g-optimalle-list">
            {optimalles.map(optimalle => <Optimalle key={optimalle.id} optimalle={optimalle} />)}
        </ul>}
        {isLoading && !reachedEnd && <div className="fa-2x loading-spinner"><i className="fal fa-spinner-third fa-spin"></i> Chargement des optimalles</div>}

        {!isLoading && optimalles.length == 0 && <div>Il n'y a pas d'optimalle disponible avec les critères demandés</div>}
    </section>
</div>)


export default withNamespaces()(OptimallesListPage);